import { Activity, ShieldCheck, Timer } from "lucide-react";
import { fmt } from "@/lib/format";

export default function TrailingStatus({ trail, large, testId }) {
  if (!trail) {
    return (
      <div className={`flex items-center gap-2 rounded-lg border border-white/5 bg-white/[0.02] ${large ? "p-3 text-sm" : "px-3 py-2 text-[11px]"} text-gray-500`} data-testid={testId}>
        <Timer size={large ? 16 : 13} /> Trailing SL: <span className="text-gray-400 font-semibold">Not started</span> · awaiting a confirmed entry
      </div>
    );
  }
  const on = trail.active;
  const color = on ? "#00FF66" : "#FFCC00";
  return (
    <div className={`rounded-lg border ${large ? "p-3" : "px-3 py-2"}`} style={{ borderColor: `${color}40`, background: `${color}0D` }} data-testid={testId}>
      <div className={`flex items-center justify-between gap-2 ${large ? "text-sm" : "text-[11px]"}`}>
        <span className="flex items-center gap-2 font-bold" style={{ color }}>
          {on ? <ShieldCheck size={large ? 16 : 13} /> : <Activity size={large ? 16 : 13} />}
          <span>Trailing SL</span>{" "}<span className="ml-1 tracking-wider">{on ? "ACTIVE" : "ARMED"}</span>
        </span>
        <span className="font-data text-gray-300">{trail.direction} @ {fmt(trail.entry)}</span>
      </div>
      <div className={`flex flex-wrap justify-between gap-x-3 gap-y-0.5 font-data mt-1.5 ${large ? "text-xs" : "text-[10px]"} text-gray-400`}>
        <span>SL now <b className="text-white">{fmt(trail.current_sl)}</b></span>
        <span>{on ? `locked from ${fmt(trail.initial_sl)}` : `activates at ${fmt(trail.trigger)}`}</span>
      </div>
    </div>
  );
}
